<template>
  <div class="storageGatewayMonitorSearch">
    <Row>
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4" style="padding-right:10px">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4" style="padding-right:10px">
        <Input
          v-model="storageGatewayName"
          :placeholder="$t('alarms.storagegateway.filterByStorageGatewayName')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['monitor:storageGatewayMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableStorageGateway from "../storage_gateway/TableStorageGateway";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
var tableStorageGateway = TableStorageGateway;
export default {
  name: "StorageGatewayMonitorSearch",
  data() {
    return {
      tag: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      stateSearchKey: [],
      storageGatewayName: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("storageGatewayName", this.storageGatewayName);
      tableStorageGateway.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 按标签搜索
    searchTag: function() {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
      eventBus.$emit("tag", this.tag);
      tableStorageGateway.methods.showAll();
    }
  }
};
</script>
<style scoped>
.storageGatewayMonitorSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/storage_gateway/StorageGatewayMonitorSearch.vue